import { Component, ViewChild } from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { Session } from '../../data/Entities';
import { Array } from '../common/Helpers';

@Component({
    selector: 'statapp',
    templateUrl: './templates/get/Stat/stat_main',
})
export class StatComponent {
    public dt: Date;
    public step: number = 1;
    public hours: number = 24;
    public fetchStatList: Array<any> = [];

    constructor(private siteServices: SiteServices) {
        this.refr();
    }

    public refr() {
        this.fetchStatList = [];
        this.siteServices.provider_Execute(
            'STAT',
            'PRICEFETCH',
            { Hours: this.hours },
            (data) => {
                this.fetchStatList = data.TagObject.PriceFetchStatItemList;
            }
        );
    }
    /*
    public next()
    {
        
        this.step++;
        this.myTabs.tabs[this.step - 1].disabled = false;
        this.myTabs.tabs[this.step - 1].active = true;
        
    }


    public prev() {

        this.step--;
        this.myTabs.tabs[this.step - 1].disabled = false;
        this.myTabs.tabs[this.step - 1].active = true;

    }*/
}
